import { render, staticRenderFns } from "./FeatureLabel.vue?vue&type=template&id=2db35c58"
import script from "./FeatureLabel.vue?vue&type=script&lang=js"
export * from "./FeatureLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports